import global$1 from './global.js';
import setGlobal$1 from './set-global.js';

var global = global$1;
var setGlobal = setGlobal$1;
var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});
var sharedStore = store;

export { sharedStore as default };
